export class ForgotPasswordRequest {
  public code: string = '';
  public deviceId: string = '';
  public password: string = '';
  public username: string = '';
}
